import axios from "./axios-handler.service";
const BASE_URL = "/api/MonitorTrafego";

export interface Trafego {
  idConsultor: number;
  nome: string;
  dataContratacao: string;
  utmSource: string;
  utmCampaign: string;
  utmMedium: string;
  utmContent: string;
  idTipoPlano: number;
  valor: number;
  estadoEntidade?: number;
}

export interface TipoPlano {
  idTipoPlano: number;
  nome: string;
  valor: number;
  valorOriginal: number;
  temDesconto: boolean;
  validade: number;
  ativo: boolean;
  descricaoValidade: string;
  validadeEmMeses: string;
  categoriaPlano: number;
}

export enum DescricaoTipoPlano {
  Gratis = "Gratis",
  MensalLite = "Mensal Lite",
  TrimestralLite = "Trimestral Lite",
  SemestralLite = "Semestral Lite",
  AnualLite = "Anual Lite",
  BonusLite = "Bonus Lite",
  Mensal = "Mensal",
  Trimestral = "Trimestral",
  Semestral = "Semestral",
  Anual = "Anual",
  Bonus = "Bonus",
}

export interface UTM {
  utmSource: Plano[];
  utmCampaign: Plano[];
  utmMedium: Plano[];
  utmContent: Plano[];
}

export interface Plano {
  utmSource: string;
  utmCampaign: string;
  utmMedium: string;
  utmContent: string;
}

export interface FiltrosMonitorTrafego {
  fonte: string;
  campanha: string;
  midia: string;
  contexto: string;
  pago: boolean | null;
  tipoPlano: TipoPlano[];
}

export class TrafegoService {
  static async listarPlanosAtivos(): Promise<TipoPlano[]> {
    const response = await axios.get<TipoPlano[]>(
      `${BASE_URL}/ListarPlanosAtivos`
    );
    return response.data;
  }

  static async ListaUTM(txtPesquisa: string): Promise<any> {
    const response = await axios.get<any>(`${BASE_URL}/ListaUTM`, {
      params: {
        txtPesquisa,
      },
    });
    return response.data;
  }

  static async ListarMonitorTrafego(filtro: FiltrosMonitorTrafego, idsPlano: string, txtPesquisa: string | null): Promise<Trafego[]> {
    const { fonte, campanha, midia, contexto, pago } = filtro;
    const response = await axios.get<Trafego[]>(`${BASE_URL}/ListarMonitorTrafego`, {
      params: {
        fonte, campanha, midia, contexto, pago, idsPlano, txtPesquisa
      },
    });
    return response.data;
  }
}